import { render, staticRenderFns } from "./UserPic.vue?vue&type=template&id=fd9d30d2&"
import script from "./UserPic.vue?vue&type=script&lang=js&"
export * from "./UserPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports